import Component from '../core/Component'
import EventBus from '../core/EventBus'
import {EVENTS} from '../core/Events'

export const STATES = {
    ACTIVE: 'is-active',
    AFTER_SWUP: 'is-after-swup'
}

export default class Alert extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            close: null
        }

        this.alertId = null
    }

    prepare() {
        this.alertId = this.element.dataset.alertId
        const localStorageAlert = localStorage.getItem('alert');

        if (!localStorageAlert || localStorageAlert !== this.alertId) {
            this.ref.close.addEventListener('click', this.handleClick)

            if(document.cookie.includes('gCookieConsent')) {
                this.show()
            }

            EventBus.on(EVENTS.SWUP_WILL_REPLACE_CONTENT, () => {
                if(document.cookie.includes('gCookieConsent')) {
                    this.element.classList.add(STATES.AFTER_SWUP)
                }
            })
        }
    }

    handleClick = event => {
        this.hide()
    }

    show() {
        this.element.classList.add(STATES.ACTIVE)
    }

    hide() {
        this.element.classList.remove(STATES.ACTIVE)
        localStorage.setItem('alert', this.alertId);

        if(window.innerWidth < 767) {
            document.querySelector('.header-Main').classList.add('is-bottom-pinned')
        }
    }
}